import apiClient from './apiClient'
import { runtimeEnv } from '@/utils/runtimeEnv'

const BASE = '/media'

export const mediaApi = {
  getAssetUrl: (systemFileName: string, inline = false): string => {
    const baseUrl = runtimeEnv.VITE_API_BASE_URL
    const inlineParam = inline ? '?inline=true' : ''
    return `${baseUrl}/api/media/${systemFileName}${inlineParam}`
  },

  checkAsset: (systemFileName: string) =>
    apiClient.head(`${BASE}/${systemFileName}`),

  downloadAsset: (systemFileName: string) =>
    apiClient.get(`${BASE}/${systemFileName}`, { responseType: 'blob' }).then(r => r.data),
}
